// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LiSE","label":"styles_label__9fjwf"};